function utf8ToBinary(value) {
    const stringValue = String(value);

    if (typeof TextEncoder !== 'function') {
        return unescape(encodeURIComponent(stringValue));
    }

    const bytes = new TextEncoder().encode(stringValue);
    let binary = '';

    for (let i = 0; i < bytes.length; i += 1) {
        binary += String.fromCharCode(bytes[i]);
    }

    return binary;
}

/**
 * Native `btoa` only accepts code units U+0000–U+00FF. Code points above that (e.g. ẽ) must be
 * UTF-8–encoded to a binary string first; do not rely only on try/catch (error shapes differ).
 */
function stringRequiresUtf8BinaryEncoding(value) {
    const stringValue = String(value);

    for (let i = 0; i < stringValue.length; i += 1) {
        if (stringValue.charCodeAt(i) > 255) {
            return true;
        }
    }

    return false;
}

export function createSafeBtoa(nativeBtoa) {
    return function safeBtoa(value) {
        const input = String(value);
        const binaryInput = stringRequiresUtf8BinaryEncoding(input)
            ? utf8ToBinary(input)
            : input;

        return nativeBtoa(binaryInput);
    };
}

export function installSafeBtoa(target = window) {
    if (!target || typeof target.btoa !== 'function') {
        return false;
    }

    if (target.__vsSafeBtoaInstalled) {
        return false;
    }

    const nativeBtoa = target.btoa.bind(target);
    target.btoa = createSafeBtoa(nativeBtoa);
    target.__vsSafeBtoaInstalled = true;

    return true;
}
